<template>
  <v-card class="px-4 py-3 mb-4">
    <div class="d-flex flex-wrap align-center">
      <span class="text-body-1 mr-auto py-1">
        {{ $t("acceptance.summary.confirmed_on", { date: confirmedOn }) }}
        <template v-if="depollution">
          · {{ $t("acceptance.deadlines.depollution") }} {{ depollution }}
        </template>
      </span>
      <span class="text-body-2 text-grey-darken-1 mr-2 py-1">
        {{ sections }}
      </span>
      <v-btn
        variant="text"
        color="primary"
        size="small"
        :append-icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        @click="$emit('update:expanded', !expanded)"
      >
        {{
          expanded
            ? $t("acceptance.summary.hide_details")
            : $t("acceptance.summary.show_details")
        }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import { dueDateText } from "@/components/Acceptance/deadlines.mjs";

// The acceptance cards folded behind the strip (their card titles).
const SECTIONS = [
  "arrival",
  "identity",
  "checklist",
  "weighings",
  "photos",
  "hazards",
];

// One-line summary of a confirmed acceptance in the PRA layout (decision Q2). Folded by default;
// the page shows the full Stage 1 layout while expanded.
export default {
  name: "AcceptanceSummary",
  props: {
    dossier: { type: Object, required: true },
    expanded: { type: Boolean, default: false },
  },
  emits: ["update:expanded"],
  computed: {
    confirmedOn() {
      return this.dossier.confirmedAt
        ? moment(this.dossier.confirmedAt).format("DD/MM/YYYY")
        : "—";
    },
    depollution() {
      return dueDateText(this.dossier, "depollution");
    },
    sections() {
      return SECTIONS.map((key) => this.$t(`acceptance.${key}.title`)).join(
        ", ",
      );
    },
  },
};
</script>
